// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "styles" + "." + "6990f9ffe691a3ed" + ".css"
}